// extracted by css-extract-rspack-plugin
export default {"cls1":"YourPaperCard-cls1_h9H","cls2":"YourPaperCard-cls2_oYp YourPaperCard-cls1_h9H"};